/**
 * Enlaces bidireccionales blog guía ↔ página de búsqueda por ciudad.
 * Usado en SearchPageLayout / ColivingAdvancedSearch (internal linking SEO).
 *
 * Madrid (GSC oct 2026): pilar editorial = los-5; guía completa + precios como secundarios.
 * Valencia / Málaga: guía completa como pilar + enlace al hub vía blogMarketplaceCta.
 */
export const CITY_BLOG_LINKS = {
  madrid: {
    blogSlug: 'los-5-colivings-top-en-madrid-y-como-encontrarlos',
    linkLabel: 'Los 5 mejores colivings en Madrid (2026)',
    extraLinks: [
      {
        blogSlug: 'precios-coliving-madrid-2026',
        linkLabel: 'Precios reales de coliving en Madrid',
      },
      {
        blogSlug: 'mejores-colivings-madrid-guia-completa-2026',
        linkLabel: 'Guía completa: barrios y operadores',
      },
    ],
  },
  barcelona: {
    blogSlug: 'mejores-colivings-barcelona-guia-completa-2026',
    linkLabel: 'Guía 2026: mejores colivings en Barcelona (barrios, precios y operadores)',
  },
  valencia: {
    blogSlug: 'mejores-colivings-valencia-guia-completa-2026',
    linkLabel: 'Guía 2026: mejores colivings en Valencia (barrios, precios y operadores)',
    extraLinks: [
      {
        blogSlug: 'coliving-vs-piso-compartido-valencia-2026',
        linkLabel: 'Coliving vs piso compartido en Valencia',
      },
    ],
  },
  malaga: {
    blogSlug: 'mejores-colivings-malaga-guia-completa-2026',
    linkLabel: 'Guía 2026: mejores colivings en Málaga (barrios, precios y operadores)',
    extraLinks: [
      {
        blogSlug: 'coliving-vs-piso-compartido-malaga-2026',
        linkLabel: 'Coliving vs piso compartido en Málaga',
      },
    ],
  },
  sevilla: {
    blogSlug: 'mejores-colivings-sevilla-guia-completa-2026',
    linkLabel: 'Guía 2026: mejores colivings en Sevilla (barrios, precios y operadores)',
  },
};

/** @param {string | undefined | null} citySlug */
export function getCityBlogLink(citySlug) {
  if (!citySlug) return null;
  const key = String(citySlug).toLowerCase();
  return CITY_BLOG_LINKS[key] ?? null;
}
